import { render, staticRenderFns } from "./GroupInfo.vue?vue&type=template&id=63e7fc9e&scoped=true&"
import script from "./GroupInfo.vue?vue&type=script&lang=js&"
export * from "./GroupInfo.vue?vue&type=script&lang=js&"
import style0 from "./GroupInfo.vue?vue&type=style&index=0&id=63e7fc9e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e7fc9e",
  null
  
)

export default component.exports